import React, {Component} from 'react';

class BaseTeamDetails extends Component {
    getImpliedTeamTotalValue() {
        const {teams, teamName} = this.props;
        return teams[teamName] ? teams[teamName].implied_run_totals : null;
    }

    getTeamTotalValue() {
        const {game, teamName} = this.props;
        return game.teams[teamName];
    }
}

export default BaseTeamDetails;
